<template>
    <ul class="list" v-if="layOut">
        <li v-for="(item, index) in items" :key="index">
            <div class="SublistCata" @click="cataBeginStudy(item.CourseID,item.ID)">
                <div class="titleTimeBox">
                    <p class="title">{{item.Title}}</p>  
                    <p class="mobileTime">{{item.Title}}{{'('+item.Duration+')'}}</p>  
                    <p class="time">时长: {{item.Duration}}</p>
                </div>
                <div class="tnpBox">
                    <p class="num">{{item.Score}}</p>
                    <p class="play"><img src="../assets/img/detial_play.svg" /><span>播放</span></p>
                    <div class="progress-wrap" v-show="item.Progress != undefined && item.Progress != 0">
                        <p v-show="item.Progress >=90" style="background-image: linear-gradient(to top, #0061FE 100%, transparent 0%)"></p>
                        <p v-show="item.Progress <90" style="background-image: linear-gradient(to top, #0061FE 50%, transparent 50%)"></p>
                    </div>
                </div>
            </div>
			<template v-if="item.Items">
				<course-tree-list :items="item.Items"></course-tree-list>
			</template>
        </li>
    </ul>
    <ul class="videolist" v-else>
        <li v-for="(item, index) in items" :key="index" @click.stop="playClick(item.ID,'clickPlay')">
            <div class="twoCatalogue" :style="item.ID == VideoId?'background-color:#fafafa':''">
                <div class="titleBox">
                    <p class="title">{{item.Title}}{{'('+item.Duration+')'}}</p>
                </div>
                <div class="tnpBox">
                    <p class="num">{{item.Score}}</p>
                    <p class="play"><img src="../assets/img/detial_play.svg" /></p>
                </div>
            </div>
			<template v-if="item.Items">
				<course-tree-list :items="item.Items" :layOut="layout" :VideoId="VideoId"></course-tree-list>
			</template>
        </li>
    </ul>
</template>

<script>
import common from './common'
export default {
    name:'CourseTreeList',
	props:{
		items: {
			type: Array,
			default(){
				return []
			}
		},
        layOut:{
            type: Boolean,
            default: true
        },
        VideoId:{
            type: Number,
            default: 0
        }
	},
    data() {
        return {
            num:0,
            layout:false
        }
    },
    methods: {
        playClick(id,type){
            common.$emit('playing',id,type);
        },
        cataBeginStudy(courseId,id){
            common.$emit('toVideoPlay',courseId,id);
        }
    },
    components: {

    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .titleTimeBox{
        display: flex;
        align-items: center;
        .time,.title{
            display: none;
        }
    }
    .play{
        display: none;
    }
    .list{
        width: 100%;
        .list{
            .SublistCata{
                padding: 15px 0 15px 20px;
            }
        }
        .SublistCata{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 15px 0 15px 10px;
            font-size: 12px;
            color: #19191A;
            cursor: pointer;
            border-bottom: 2px solid #fafafa;
        }
    }
    .tnpBox{
        font-size: 14px;
        display: flex;
        width: 30px;
        .num{
            margin-right: 5px;
        }
    }
    .videolist{
        width: 100%;
        li ul .twoCatalogue{
            padding-left: 10px;
        }
        .twoCatalogue{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            border-bottom: 2px solid #fafafa;
            padding: 10px 0;
        }
        .play{
            font-size: 12px;
            color: #0061FE;
            cursor: pointer;
            img{
                display: none;
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
@media screen and (min-width: 1445px) {
    .titleTimeBox{
        width: 68%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mobileTime{
            display: none;
        }
    }
    .list {
        width: 100%;
        .list{
            width: 98%;
            margin-left: 2%;
            .SublistCata .tnpBox{
                width: 20%;
            }
            .titleTimeBox{
                width: 67.2%;
            }
        }
        .SublistCata{
            padding: 15px 19px 15px 30px;
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            box-sizing: border-box;
            border-bottom: 2px solid #fafafa;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: flex;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .tnpBox{
                width: 19.5%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
            }
            .play{
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

                display: none;
                align-items: center;
                font-size: 14px;
                color: #0061FE;
                img{
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
    .videolist{
        width: 100%;
        .videolist{
            width: 96%;
            margin-left: 4%;
            .twoCatalogue{
                padding: 15px 19px 15px 30px;
            }
        }
        .tnpBox{
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
        }
        .titleBox{
            width: 75%;
        }
        .twoCatalogue{
            padding: 15px 19px 15px 30px;
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            border-bottom: 2px solid #fafafa;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: block;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .play{
                display: none;
            }
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .titleTimeBox{
        width: 68%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mobileTime{
            display: none;
        }
    }
    .list {
        width: 100%;
        .list{
            width: 98%;
            margin-left: 2%;
            .SublistCata .tnpBox{
                width: 20%;
            }
            .titleTimeBox{
                width: 67.2%;
            }
        }
        .SublistCata{
            padding: 15px 19px 15px 30px;
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            border-bottom: 2px solid #fafafa;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: flex;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .tnpBox{
                width: 19.5%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                position: relative;
            }
            .play{
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

                display: none;
                align-items: center;
                font-size: 14px;
                color: #0061FE;
                img{
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
    .videolist{
        width: 100%;
        .videolist{
            width: 96%;
            margin-left: 4%;
            .twoCatalogue{
                padding: 15px 19px 15px 30px;
            }
        }
        .tnpBox{
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            position: relative;
        }
        .titleBox{
            width: 75%;
        }
        .twoCatalogue{
            padding: 15px 19px 15px 30px;
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            border-bottom: 2px solid #fafafa;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: block;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .play{
                display: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CourseTreeList.vue